import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import {
	AppModalService,
	ModalData,
} from '@datachain/ui-sdk/components/app-modal';
import { Observable } from 'rxjs';
import { DcIcons } from 'src/app/ui/app-dc.icons';

export enum DashboardAction {
	Delete = 'delete',
}

export interface IDashboardActionModalData {
	dashboardId: number | Array<number>;
	element: string;
	action: DashboardAction;
}

@Component({
	selector: 'app-dashboard-action-popup',
	templateUrl: './dashboard-action-popup.component.html',
	styleUrls: ['./dashboard-action-popup.component.scss'],
})
export class DashboardActionPopupComponent<T extends IDashboardActionModalData>
	extends DcBaseComponent
	implements OnInit
{
	public readonly Icons = DcIcons;
	public vo$!: Observable<{
		element: string;
		dashboardId: number | Array<number>;
		isMultipleElement: boolean;
		action: DashboardAction;
	}>;
	public confirmDeletion = false;

	protected readonly DcIcons = DcIcons;
	protected readonly DashboardAction = DashboardAction;
	public constructor(
		private readonly modalService: AppModalService,
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'dashboard-action';
	}

	public ngOnInit(): void {
		super.ngOnInit();
		this.vo$ = combineAll({
			element: this.modalData.element,
			isMultipleElement:
				Array.isArray(this.modalData.dashboardId) &&
				this.modalData.element === '',
			dashboardId: this.modalData.dashboardId,
			action: this.modalData.action,
		});
	}

	public confirmAction(): void {
		this.modalService.closeActiveModal({
			shouldLaunch: true,
		});
	}
}
